import React, { useCallback, useEffect, useState } from 'react';
import { Button, Card } from 'react-bootstrap';

import CardHeader from 'react-bootstrap/esm/CardHeader';

import { environment, Method, Service } from 'shared-components/configuration';
import useSWQuery from 'shared-components/hooks/useSWQuery';
import { CORPO_STATS, FORCE_SYNC_CORPO } from 'shared-components/queries/graphql';

export const CorpoStats = () => {
  const [corpoStats, setCorpoStats] = useState<any>({});
  const resyncCorpoStats = useSWQuery({
    service: Service.GRAPHQL,
    method: Method.QUERY,
    returnObjectName: 'forceCorpoResync',
    data: {
      query: FORCE_SYNC_CORPO,
      variables: {}
    },
    auto: false,
    onResponse: (data: any) => {
      console.log(data);
    }
  });

  const getCorpoStats = useSWQuery({
    service: Service.GRAPHQL,
    method: Method.QUERY,
    returnObjectName: 'getCorpoStats',
    data: {
      query: CORPO_STATS,
      variables: {}
    },
    auto: false,
    onResponse: (data: any) => {
      const jsonData = JSON.parse(data);
      setCorpoStats(jsonData.getCorpoStats);
    }
  });
  const refreshCorpoStats = useCallback(() => {
    getCorpoStats.execute({});
  }, [getCorpoStats]);

  useEffect(() => {
    refreshCorpoStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Card style={{ margin: '10px' }}>
        <CardHeader>
          Corporate stats &nbsp; <Button onClick={refreshCorpoStats}>Update</Button> &nbsp;{' '}
          {environment.startsWith('admin') && (
            <Button
              onClick={() => {
                resyncCorpoStats.execute({});
              }}
            >
              Resync
            </Button>
          )}
        </CardHeader>
        <table style={{ margin: '10px' }}>
          <tr>
            <td>Balance:</td>
            <td>
              {corpoStats.sebBalance} {corpoStats?.currency?.toUpperCase()}
            </td>
          </tr>
          <tr>
            <td>Current spent:</td>
            <td>
              {Number(corpoStats.currentSpend).toFixed(2)} {corpoStats?.currency?.toUpperCase()}
            </td>
          </tr>
          <tr>
            <td>Total limit:</td>
            <td>
              {corpoStats.totalLimit} {corpoStats?.currency?.toUpperCase()}
            </td>
          </tr>
          <tr>
            <td>Limit per transaction:</td>
            <td>
              {corpoStats.perTxLimit} {corpoStats?.currency?.toUpperCase()}
            </td>
          </tr>
          <tr>
            <td>Next Reset:</td>
            <td>{corpoStats.nextReset}</td>
          </tr>
        </table>
      </Card>
    </>
  );
};
